import { z } from "zod";

// `/?to=/data/candidates` opens that page in the viewer's current dataset. PR preview comments link this
// way because a link cannot know which dataset each viewer uses. Only plain path segments are accepted,
// so the target can never leave the app.
export const homeSearchSchema = z.object({
  to: z
    .string()
    .regex(/^(\/[\w-]+)+$/)
    .optional()
    .catch(undefined),
});

/** Page to open in the dataset: the requested one, or the dataset's chats. */
export function datasetHomePath(slug: string, to: string | undefined): string {
  return `/${slug}${to ?? "/chats"}`;
}

/** Dataset page for a `/?to=` deeplink URL, or null when the URL is not a valid deeplink. */
export function homeDeeplinkPath(url: URL, slug: string): string | null {
  if (url.pathname !== "/") return null;

  const { to } = homeSearchSchema.parse({ to: url.searchParams.get("to") ?? undefined });
  return to ? datasetHomePath(slug, to) : null;
}
